<template>
    <div class="animated fadeIn">
        <div>
            Prima incasata
            <b-spinner small v-if="loadingPaymentsAmount" /> <strong v-else> {{formatter.format(ordersPaymentsAmount)}}</strong>
        </div>

        <div>
            Prima subscrisa:
            <b-spinner small v-if="loadingAmount" /> <strong v-else>{{formatter.format(ordersAmount)}}</strong>
        </div>
        <!--<div>Comenzi: <b-spinner small v-if="loading" /> <strong v-else> {{ordersCount}}</strong></div>-->
    </div>
</template>
<script>
    import { widgetsService } from '../../services/WidgetsService';
    export default {
        name: 'OrdersTotals',

        components: {

        },
        props: {
            filterObj: {},
            filterText: {
                type: String
            }
        },
        data: () => {
            return {
                loadingPaymentsAmount: true,
                loadingAmount: true,
                ordersAmount: 0,
                ordersPaymentsAmount: 0,
                 formatter: new Intl.NumberFormat('ro-RO', {
                    style: 'currency',
                    currency: 'RON',
                })
            }
        },
        created() {
            this.refresh();
        },
        methods: {
            refresh: function () {
                this.loadingAmount = true;
                widgetsService.getTotalAmount(this.filterObj, this.filterText).then((response) => {
                    this.ordersAmount = response.data;
                    this.loadingAmount = false;
                })

                this.loadingPaymentsAmount = true;
                widgetsService.getPaymentAmount(this.filterObj, this.filterText).then((response) => {
                    this.ordersPaymentsAmount = response.data;
                    this.loadingPaymentsAmount = false;
                })
            }
        }

    }
</script>
